/* eslint-disable */
import React from 'react';
import { useContext, useState, useEffect } from 'react';
import { MainContext } from '../../../context/ApiContext';
import { Nav, NavbarForm } from './styles';
import { DateTime } from 'luxon';
import Chip from '@material-ui/core/Chip';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import useApp from '../../../hooks/useApp';
import useSWR from 'swr';
import { fetcher } from '../../../service/SWRFetcher';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '200px',
  },
}));

const DatePeriodFilter = ({ userId, filters, setFilters }) => {
  const { partners: allPartners, insurances, channels, brokers, technical_teams } = useApp();

  const dateNow = DateTime.now().toISODate();
  const dateLastMonth = DateTime.now().plus({ months: -1 }).toISODate();
  const [dates, setDates] = useState({
    date_ini: dateLastMonth,
    date_end: dateNow,
  });
  const [partners, setPartners] = useState([]);
  const [insurance, setInsurance] = useState([]);
  const [brokerId, setBrokerId] = useState();
  const [technicalTeam, setTechnicalTeam] = useState();
  const [channelId, setChannelId] = useState();

  const { values, getters, creators } = useContext(MainContext);

  const classes = useStyles();

  // const { data: users } = useSWR(`/users`, fetcher);

  function handleSubmit(event, getters) {
    event.preventDefault();
    console.log(partners);
    // console.log(event.target.elements)

    let filters = {
      date_ini: event.target.elements[0].value,
      date_end: event.target.elements[1].value,
      partner_id: partners.map((p) => ({ id: p.id })) || null,
      insurance_id: insurance.map((i) => ({ id: i.id })) || null,
      broker_id: brokerId?.map((b) => b.id) || null,
      technical_team: technicalTeam || null,
      channel_id: channelId?.map((c) => ({ id: c.id })) || null,
      paginate: null,
    };
    setFilters(filters);
    // console.log(filters)
    // getters.getLostSaleReport(filters)
  }

  const filteredChannels = channels.filter((channel) => ![6, 19, 20, 21, 26, 27, 28].includes(channel.id));

  return (
    <Nav>
      <div className="filter">Filtros</div>

      <NavbarForm>
        <form className="form" onSubmit={(e) => handleSubmit(e, getters)}>
          <div className="inputs">
            <div className="date_ini">
              <input
                type="date"
                name="date_ini"
                className="input-form"
                placeholder="Data Inicial"
                value={dates.date_ini}
                onChange={(e) => setDates(e)}
              />
            </div>
            <div className="date_end">
              <input
                type="date"
                name="date_end"
                className="input-form"
                placeholder="Data Final"
                value={dates.date_end}
                onChange={(e) => setDates(e)}
              />
            </div>
          </div>
          {/* https://material-ui.com/pt/components/autocomplete/ */}
          <Autocomplete
            multiple
            // className="input-form"
            // id="tags-standard"
            options={allPartners}
            getOptionLabel={(option) => option?.name}
            onChange={(event, value) => setPartners(value)}
            renderInput={(params) => (
              <TextField {...params} className="autocomplete" variant="standard" placeholder="Empresa" />
            )}
          />
          {/* <Autocomplete
            multiple
            options={insurances ? insurances.filter((i) => i.id <= 3) : []}
            getOptionLabel={(option) => option?.name}
            onChange={(e, value) => setInsurance(value)}
            renderInput={(params) => (
              <TextField {...params} className="autocomplete" variant="standard" placeholder="Tipos de Estoque" />
            )}
          /> */}
          <Autocomplete
            options={technical_teams || []}
            getOptionLabel={(option) => option?.description}
            onChange={(e, value) => setTechnicalTeam(value)}
            renderInput={(params) => (
              <TextField {...params} className="autocomplete" variant="standard" placeholder="Equipe" />
            )}
          />
          <Autocomplete
            multiple
            options={brokers || []}
            getOptionLabel={(option) => option?.name}
            onChange={(e, value) => setBrokerId(value)}
            renderInput={(params) => (
              <TextField {...params} className="autocomplete" variant="standard" placeholder="Corretor" />
            )}
          />

          <Autocomplete
            multiple
            options={filteredChannels ? filteredChannels : []}
            getOptionLabel={(option) => option?.name}
            onChange={(e, value) => setChannelId(value)}
            renderInput={(params) => (
              <TextField {...params} className="autocomplete" variant="standard" placeholder="Canais" />
            )}
          />
          <div>
            <button className="button" type="submit">
              Filtrar
            </button>
          </div>
        </form>
      </NavbarForm>
    </Nav>
  );
};

export default DatePeriodFilter;
